// const Map = ({ list = [], render }) => {
//   return list?.map(render);
// };

// export default Map;
import React from "react";

const Map = ({ list = [], render }) => {
  return list?.map((item, index) => (
    <React.Fragment key={index}>
      {render(item, index)}
    </React.Fragment>
  ));
};

export default Map;